import React from 'react';
import { FileDown } from 'lucide-react';

/**
 * Peças compartilhadas pelos três painéis de relatório.
 *
 * Vivem fora dos painéis porque componente declarado dentro de outro vira um
 * tipo novo a cada render e o React remonta a subárvore — o mesmo defeito que
 * fazia os campos numéricos da FIV perderem o foco.
 */

export const pct = (v) => (v === null || v === undefined ? '—' : `${v}%`);
export const num = (v) => (Number(v) || 0).toLocaleString('pt-BR');
export const dinheiro = (v) =>
  `R$ ${(Number(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;


/**
 * O botão que imprime o painel.
 *
 * Fica ao lado do título da tabela de detalhe, e não no topo da tela, porque o
 * que ele gera É aquela tabela com os indicadores acima — colar o botão no
 * conteúdo que ele produz evita a dúvida de "o PDF sai do quê".
 */
export const BotaoPDF = ({ onClick, rotulo = 'Exportar PDF' }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-1.5 text-xs text-slate-700 bg-white border border-slate-300
               hover:bg-slate-50 px-2.5 py-1.5 rounded-lg transition-colors whitespace-nowrap"
  >
    <FileDown className="w-3.5 h-3.5" /> {rotulo}
  </button>
);

/**
 * O número que o painel lidera. Um por aba, de propósito: se tudo é grande,
 * nada é. Figuras proporcionais — `tabular-nums` dá a cada dígito a largura do
 * zero, e em corpo grande isso deixa o número frouxo.
 */
export const Destaque = ({ rotulo, valor, detalhe }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5">
    <p className="text-sm text-slate-500">{rotulo}</p>
    <p className="text-5xl font-semibold text-slate-900 leading-tight mt-1">{valor}</p>
    {detalhe && <p className="text-sm text-slate-500 mt-1">{detalhe}</p>}
  </div>
);

export const Indicador = ({ rotulo, valor, detalhe }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-4">
    <p className="text-xs text-slate-500">{rotulo}</p>
    <p className="text-2xl font-semibold text-slate-900 leading-tight mt-0.5">{valor}</p>
    {detalhe && <p className="text-xs text-slate-400 mt-0.5">{detalhe}</p>}
  </div>
);

export const Cartao = ({ titulo, subtitulo, children }) => (
  <div className="bg-white rounded-xl border border-slate-200">
    <div className="px-5 pt-4 pb-3">
      <h3 className="text-sm font-semibold text-slate-800">{titulo}</h3>
      {subtitulo && <p className="text-xs text-slate-500 mt-0.5">{subtitulo}</p>}
    </div>
    <div className="px-5 pb-5">{children}</div>
  </div>
);

export const Vazio = ({ mensagem }) => (
  <div className="bg-white rounded-xl border border-slate-200 py-16 text-center text-slate-500">
    <p className="text-sm">{mensagem}</p>
  </div>
);

/** Tabela com cabeçalho recessivo e números alinhados à direita. */
export const Tabela = ({ titulo, subtitulo, colunas, linhas, acao }) => (
  <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
    <div className="px-5 pt-4 pb-3 flex items-start justify-between gap-3">
      <div>
        <h3 className="text-sm font-semibold text-slate-800">{titulo}</h3>
        {subtitulo && <p className="text-xs text-slate-500 mt-0.5">{subtitulo}</p>}
      </div>
      {acao}
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-slate-50 border-y border-slate-200 text-slate-500">
            {colunas.map((c, i) => (
              <th key={c.chave}
                className={`px-3 py-2.5 text-xs font-semibold ${c.numerica ? 'text-right' : 'text-left'} ${
                  i === 0 ? 'pl-5' : ''} ${i === colunas.length - 1 ? 'pr-5' : ''}`}>
                {c.rotulo}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {linhas.map((l, li) => (
            <tr key={l.chave ?? li} className="hover:bg-slate-50">
              {colunas.map((c, i) => (
                <td key={c.chave}
                  className={`px-3 py-2 ${c.numerica ? 'text-right tabular-nums' : ''} ${
                    i === 0 ? 'pl-5 text-slate-800' : 'text-slate-600'} ${
                    i === colunas.length - 1 ? 'pr-5' : ''} ${c.forte ? 'text-slate-900 font-semibold' : ''}`}
                  title={c.titulo ? c.titulo(l) : undefined}>
                  {c.valor(l)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
